module.exports = __webpack_public_path__ + "iconaCLASSIFICA.svg?0e55541ebcd111b9b35d2a2e03dfca52";


//////////////////
// WEBPACK FOOTER
// ./src/assets/iconaCLASSIFICA.svg
// module id = 798
// module chunks = 0